import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http'
import { ModuleWithProviders, NgModule } from '@angular/core'
import { HttpService } from './services/http.service'

@NgModule({
  declarations: [],
  exports: [],
  imports: [],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class RestModule {
  static forRoot(): ModuleWithProviders<RestModule> {
    return {
      ngModule: RestModule,
      providers: [HttpService],
    }
  }
}
